import React from 'react'
import { Skeleton } from '@/design-system/Skeleton'

/* ------------------------------------------------------------------ */
/*  PageSkeleton — full-page loading skeleton for Suspense fallbacks   */
/*  Shown while lazy-loaded route chunks are fetching                   */
/*  See ARCHITECTURE.md §17                                             */
/* ------------------------------------------------------------------ */

export function PageSkeleton() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-8 sm:px-6 lg:px-8" aria-busy="true" aria-label="Laddar sida…">
      {/* Page header skeleton */}
      <Skeleton variant="text" className="mb-2 h-8 w-48" />
      <Skeleton variant="text" className="mb-6 h-4 w-72" />

      {/* Content block skeletons */}
      <div className="space-y-4">
        <Skeleton variant="rect" className="h-32 w-full rounded-lg" />
        <div className="grid gap-4 sm:grid-cols-2">
          <Skeleton variant="rect" className="h-24 w-full rounded-lg" />
          <Skeleton variant="rect" className="h-24 w-full rounded-lg" />
        </div>
        <Skeleton variant="rect" className="h-48 w-full rounded-lg" />
      </div>
    </div>
  )
}

PageSkeleton.displayName = 'PageSkeleton'
